module.exports = __webpack_public_path__ + "static/media/kokufu.2fd4b8af.jpg";